
export default {
  props: ['separator', 'separatorTop']
}
